module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-1-img-sp@2x_b558226fbcde6fceef6cf629750a3387.png";